import { render } from "./InformacijeFooter.vue?vue&type=template&id=f9983824"
import script from "./InformacijeFooter.vue?vue&type=script&lang=js"
export * from "./InformacijeFooter.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__